import { createSelector } from "reselect";
import { cloneDeep, get } from "lodash";
import selectorUtils from "../selectorUtils.js";
import { RESOURCE_URI_CHUNKS } from "../../../constants/entity.js";

// -- QUERIES -- //

const invoicesDataQuery = state => get(state, "invoices.dataMap", null);
const invoicesIndexQuery = state => get(state, "invoices.dataIndex", null);
const imagesDataMapQuery = state => get(state, "images.dataMap", null);

const invoiceQuery = (state, props) => {
  const invoices = get(state, "invoices.dataMap", null);

  if (!invoices) return null;

  const invoiceId = props.id
    ? props.id
    : selectorUtils.getAtIdFromMatchProps(props, RESOURCE_URI_CHUNKS.INVOICES);

  return invoices[invoiceId];
};

// -- SELECTORS -- //

const selectInvoice = id => {
  return createSelector(
    [invoiceQuery, imagesDataMapQuery],
    (invoice, images) => {
      if (!invoice) return null;

      const result = cloneDeep(invoice);
      if (invoice.images) {
        result.images = result.images.map(image => {
          const operatingSystem = get(
            images,
            `${image["@id"]}.operatingSystem`,
            undefined
          );
          if (operatingSystem) {
            image.operatingSystem = operatingSystem;
          }
          return image;
        });
      }

      return result;
    }
  );
};

const selectLatestInvoices = limit => {
  return createSelector(
    [invoicesIndexQuery, invoicesDataQuery],
    (invoicesIndex, invoicesData) => {
      // bail early if we don't have an invite
      if (!invoicesIndex || !invoicesData) return null;

      return invoicesIndex.slice(0, limit).map(item => invoicesData[item]);
    }
  );
};

// using the following export pattern so we can mock more easily using jest

const invoicesSelector = {
  invoiceQuery,
  selectLatestInvoices,
  selectInvoice
};

export default invoicesSelector;
